import createVueComponent from '../createVueComponent';

const Asterisk = createVueComponent('AsteriskIcon', [
  ['path', { d: 'M12 6v12', key: '1vza4d' }],
  ['path', { d: 'M17.196 9 6.804 15', key: '1ah31z' }],
  ['path', { d: 'm6.804 9 10.392 6', key: '1b6pxd' }],
]);

export default Asterisk;
